




























































import { Component, Prop, Watch } from 'vue-property-decorator';
import { Validation, validationMixin } from 'vuelidate';
import { Validations } from 'vuelidate-property-decorators';
import { mixins } from 'vue-class-component';

import {
	formatPaymentMethod,
	hasAccountFields,
	OrgPaymentMethod,
	paymentMethodError,
} from '@/models/org-payment-method';
import { accountFieldValidators } from '@/common/Validators';
import { OrdwayService } from '@/services/ordway-service';
import Toast from '@/components/display/toast.vue';
import { AxiosError } from 'axios';

import { OrgsApi } from '@/api';

@Component({
	methods: {
		paymentMethodError,
	},
})
export default class EditPaymentMethod extends mixins(validationMixin) {
	@Prop() public paymentMethod!: OrgPaymentMethod;
	public submitting: boolean = false;
	private paymentMethodAlreadyActive: boolean = this.paymentMethod.active === true;

	@Validations()
	public validations() {
		return {
			paymentMethod: accountFieldValidators(this.paymentMethod.type),
		};
	}

	@Watch('paymentMethod.active')
	public ensurePaymentMethodApproved(paymentMethodActive: boolean): void {
		if (paymentMethodActive) {
			this.paymentMethod.approved = true;
		}
	}

	get paymentMethodName(): string {
		return formatPaymentMethod(this.paymentMethod.type);
	}

	// This is really just 'isDirectInvoice', might change - pending on if we add another payment method billToParent.
	get shouldShowAccountFields(): boolean {
		return hasAccountFields(this.paymentMethod.type);
	}

	get canSubmit(): boolean {
		if (this.submitting) {
			return false;
		}
		if (this.$v.paymentMethod !== undefined) {
			const { $invalid } = this.$v.paymentMethod;
			return !$invalid;
		}
		return false;
	}

	public fieldWithValidator(fieldName: string): Validation {
		return this.$v.paymentMethod[fieldName] as Validation;
	}

	public async onSubmit(): Promise<void> {
		this.submitting = true;
		if (this.paymentMethodAlreadyActive === false && this.paymentMethod!.active === true) {
			this.$bvModal.show('confirm-active-edit');
		} else {
			await this.saveChanges();
		}
	}

	public async saveChanges(): Promise<void> {
		await this.updatePaymentMethod();
		this.$emit('success');
		this.closeModal();
	}

	public closeModal(): void {
		this.$bvModal.hide('editPaymentMethod');
	}

	public async deletePaymentMethod() {
		if (
			confirm(
				`Are you sure you wish to permanently delete the ${this.paymentMethod.type} payment Method?`,
			)
		) {
			try {
				await new OrgsApi().orgDeletePaymentMethod(this.paymentMethod.orgId, this.paymentMethod.id);
				new Toast().makeToast(
					'Changes have been applied',
					'Payment method deleted successfully',
					'success',
				);
			} catch (e) {
				const error = e as AxiosError;
				this.handleError(error);
			} finally {
				this.submitting = false;
				this.$emit('success');
				this.closeModal();
			}
		}
	}

	private async updatePaymentMethod(): Promise<void> {
		try {
			await OrdwayService.updatePaymentMethod(this.paymentMethod.orgId, this.paymentMethod);
			new Toast().makeToast(
				'Changes have been applied',
				'Payment method updated successfully',
				'success',
			);
		} catch (e) {
			const error = e as AxiosError;
			this.handleError(error);
		} finally {
			this.submitting = false;
		}
	}

	private handleError(error: AxiosError): void {
		let errorMessage: string;
		if (error.response) {
			errorMessage = error.response.data.errors;
		} else {
			errorMessage =
				'There was a problem updating the payment method - changes have not been applied.';
		}
		new Toast().makeToast(errorMessage, 'Error updating payment method', 'danger');
	}
}
